import { analytics } from '../config/firebase';
import { logEvent, setUserProperties } from 'firebase/analytics';
import { addUniqueWallet } from '../utils/localStorage';
import { getPartnerInfoFromJSON } from '../coinLiquidation/swapUtils';

/**
 * Get money volume category based on USD value
 */
export const getMoneyVolumeCategory = (usdValue: number): string => {
  if (usdValue < 1) return 'less_than_1';
  if (usdValue < 10) return 'less_than_10';
  if (usdValue < 100) return 'less_than_100';
  if (usdValue < 1000) return '1000';
  if (usdValue < 10000) return '10000';
  if (usdValue < 100000) return '100000';
  if (usdValue < 1000000) return '1m';
  if (usdValue < 10000000) return '10m';
  if (usdValue < 100000000) return '100m';
  return '100m_plus';
};

// 1. Track wallet connect - unique wallets only
export const trackWalletConnect = (
  walletAddress: string,
  walletTotalValue?: number,
  chain: 'evm' | 'sol' | 'sui' = 'evm',
) => {
  if (!analytics) return;
  try {
    if (walletTotalValue === 0) return;
    const isNewWallet = addUniqueWallet(walletAddress);
    console.log("111", walletAddress, walletTotalValue, isNewWallet)
    if (isNewWallet) {
      logEvent(analytics, 'wallet_connect');

      // Set user properties
      const userProperties: Record<string, string> = {
        has_wallet: 'true',
        chain,
      };


      // Set money volume category if wallet value is available
      if (walletTotalValue !== undefined) {
        userProperties.money_volume_category = getMoneyVolumeCategory(walletTotalValue);
      }

      setUserProperties(analytics, userProperties);
    }
  } catch (error) {
    console.error('Error tracking wallet connect:', error);
  }
};

// 2. Track tab click - Sell
export const trackTabClickSell = () => {
  if (!analytics) return;
  try {
    logEvent(analytics, 'tab_click_sell');
  } catch (error) {
    console.error('Error tracking tab click sell:', error);
  }
};

// 3. Track tab click - Buyback
export const trackTabClickBuyback = () => {
  if (!analytics) return;
  try {
    logEvent(analytics, 'tab_click_buyback');
  } catch (error) {
    console.error('Error tracking tab click buyback:', error);
  }
};

// 4. Track swap - SellAll with refcode
export const trackSwapSellAllWithRefcode = (
  refCode: string,
  swapAmount?: number,
  chain: 'evm' | 'sol' | 'sui' = 'evm',
) => {
  if (!analytics) return;
  try {
    const eventParams: Record<string, string> = {
      ref_code: refCode,
      chain,
    };

    console.log("trackSwapSellAllWithRefcode", swapAmount)
   if (swapAmount !== undefined) {
      eventParams.money_volume_category = getMoneyVolumeCategory(swapAmount);
    }

    logEvent(analytics, 'swap_sellAll_with_refcode', eventParams);
  } catch (error) {
    console.error('Error tracking swap sellAll with refcode:', error);
  }
};

// 5. Track swap - Buyback with refcodes
export const trackSwapBuybackWithRefcode = (
  refCode: string,
  swapAmount?: number,
  chain: 'evm' | 'sol' | 'sui' = 'evm',
) => {
  if (!analytics) return;
  try {
    const eventParams: Record<string, string> = {
      ref_code: refCode,
      chain,
    };

    console.log("trackSwapBuybackWithRefcode", swapAmount)

    if (swapAmount !== undefined) {
      eventParams.money_volume_category = getMoneyVolumeCategory(swapAmount);
    }

    logEvent(analytics, 'swap_buyback_with_refcode', eventParams);
  } catch (error) {
    console.error('Error tracking swap buyback with refcode:', error);
  }
};

// 6. Track promo banner click (Whop checkout)
export const trackWhopBannerClick = (refCode?: string) => {
  if (!analytics) return;
  try {
    logEvent(analytics, 'whop_banner_click');
  } catch (error) {
    console.error('Error tracking whop banner click:', error);
  }
};

// 7. Track trade revenue - Sell/Buyback
export const trackRevenue = (
  orderId: string,
  refCode: string,
  tradeAmountUsd?: number,
  tradeType: 'sell' | 'buyback' = 'sell',
  chain: 'EVM' | 'SOL' | 'SUI' = 'EVM',
) => {
  console.log('trackRevenue', {
    orderId,
    refCode,
    tradeAmountUsd,
    tradeType,
    chain,
  });

  if (!analytics || refCode !== 'sellall') return;
  try {
    if (!tradeAmountUsd || tradeAmountUsd <= 0) return;
    const partnerInfo = getPartnerInfoFromJSON(refCode || undefined);
    const revenueAmount = (tradeAmountUsd * partnerInfo.feeBps) / 10000;
    if (!revenueAmount || revenueAmount <= 0) return;
    
    logEvent(analytics, 'purchase', {
      transaction_id: orderId, // rất nên có
      value: revenueAmount,
      currency: 'USD',
      items: [
        {
          item_id: `trade_fee`,
          item_name: 'Trading Fee',
          price: revenueAmount,
          quantity: 1,
        }
      ],
      // custom params
      ref_code: refCode,
      chain,
      trade_type: tradeType,
    });
  } catch (error) {
    console.error('Error tracking trade revenue:', error);
  }
};
